import React from 'react';
import styled from 'styled-components/macro';

// import { Card } from './Card';

import productsData from '../res/json_data.json';

const ProductRow = styled.div`
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px;
  margin: 16px;
  height: 132px;

  & img {
    height: 100px;
    float: left;
  }

  & .product-price {
    font-weight: bold;
    font-size: 140%;
  }
`;

const Product = ({info}) => {console.log(info);return(
  <ProductRow>
    <img src={info.img} alt="" />
    <h4>{info.name}</h4>
    <p>{info.price}</p>
  </ProductRow>
)};


// const ProductsDiv = styled.div`
//   width: 100%;
//   height: 100%;

//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: space-around;
// `;

const Products = () => (
  <>
    {productsData.map((el) => <Product info={el}/>)}
  </>
);

export default Products;
